document.addEventListener("DOMContentLoaded", function(){
    let filter = document.querySelector('[data-filter]');
    var itemsContainer = $(".awards_section-accordions");
    var items = document.querySelectorAll('.awards_section-accordions>[data-date]');
    let anchors = document.querySelectorAll('.anchors .anchor');

    let itemCount = document.querySelector('.awards_section-title .title-badge');
    let checkedItemValue = document.querySelector('.swiper-slide.anchor.active>[data-value]').dataset.value;
    let checkedItemsNum = document.querySelectorAll(`.awards_section-accordions>[data-tag="${checkedItemValue}"]`).length;
    itemCount.textContent = '[' + checkedItemsNum + ']';

    items.forEach(function (item){
        if(item.dataset.tag != 'awards' ){
            item.classList.add('hide');
        }
    })
    calcPositionItem('newest');
    filter.querySelector('select').onchange = (e)=>{
        calcPositionItem(e.target.value);
    }
    let num = 0;
    filter.querySelectorAll('a').forEach(function(item){
        item.addEventListener('click', function (e){
            e.preventDefault();
            if(anchors.length > 0){
                anchors.forEach(function(item){
                    item.classList.remove('active');
                })
            }
            e.target.closest('.anchor').classList.add('active');
            items.forEach(function (item){
                if(e.target.dataset.value == item.dataset.tag){
                    item.classList.remove('hide');
                    num++;
                }else{
                    item.classList.add('hide');
                }
            })
            document.querySelector('.awards_section-title .title-badge').textContent = '[' + num + ']';
            num = 0;
            if (document.querySelector('.awards_section-header')) {
                setTimeout(function(){
                    const offset = 10;
                    const rect = document.querySelector('.awards_section-header').getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    window.scrollTo({
                        top: rect.top + scrollTop - offset,
                        behavior: 'smooth'
                    });
                }, 600);
            }
        })

    });




    function calcPositionItem(value) {
        let selectedTag = document.querySelector('.swiper-slide.anchor.active a').dataset.value;
        var elements = itemsContainer.children('[data-date]').detach().get();
        if(value == 'newest'){
            elements.sort(function(a, b) {
                return new Date($(b).data("date")) - new Date($(a).data("date"));
            });
            itemsContainer.append(elements);
        }else if(value == 'oldest'){
            elements.sort(function(a, b) {
                return new Date($(a).data("date")) - new Date($(b).data("date"));
            });
            itemsContainer.append(elements);
        }else {
            itemsContainer.append(items);
        }
    }

});
